module.exports = __webpack_public_path__ + "static/media/motive.a05899a4.webp";